import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import Form, { Field } from '@atlaskit/form';
import { DiscountType } from '@atlassian/mpac-api-client';
import { AtlassianProductHostingTypeValues } from '@atlassian/mpac-types/dist/GraphQLGateway.gql.types';
import React from 'react';
import PricingTable from "../../../../../common/components/PricingTable";
import { getPromotionDiscountNote } from "../../../../utils/createPromotion.utils";
import { DiscountAmountStageDefaultValues, Stages } from "../constants";
import PromotionFooter from "../PromotionFooter";
import { PromotionDiscountPercentField, PromotionSubscriptionTypeField } from "./DiscountAmountFormFields";

const DiscountAmount = ({
  mpacBaseUrl,
  promotionBasicsData,
  discountAmountData,
  onChange
}) => {
  var _discountAmountData$d;

  const onSubmit = formData => {
    onChange(Stages.ELIGIBILITY_CRITERIA, _objectSpread(_objectSpread({}, formData), {}, {
      discountType: DiscountType.FLAT_DISCOUNT
    }));
  };

  const flatDiscountInitialValue = (_discountAmountData$d = discountAmountData === null || discountAmountData === void 0 ? void 0 : discountAmountData.discountPercent) !== null && _discountAmountData$d !== void 0 ? _discountAmountData$d : DiscountAmountStageDefaultValues.FLAT_DISCOUNT;
  const isSelectedHostingIsCloud = promotionBasicsData.hostingType.value === AtlassianProductHostingTypeValues.Cloud;
  return /*#__PURE__*/React.createElement(Form, {
    onSubmit: onSubmit,
    novalidate: true
  }, ({
    formProps,
    setFieldValue,
    getValues
  }) => {
    var _discountAmountData$s;

    return /*#__PURE__*/React.createElement("form", formProps, isSelectedHostingIsCloud && /*#__PURE__*/React.createElement(PromotionSubscriptionTypeField, {
      defaultValue: (_discountAmountData$s = discountAmountData === null || discountAmountData === void 0 ? void 0 : discountAmountData.subscriptionType) !== null && _discountAmountData$s !== void 0 ? _discountAmountData$s : DiscountAmountStageDefaultValues.SUBSCRIPTION_TYPE
    }), /*#__PURE__*/React.createElement(PromotionDiscountPercentField, {
      defaultValue: flatDiscountInitialValue,
      setFieldValue: setFieldValue
    }), /*#__PURE__*/React.createElement(Field, {
      name: "discountPercent",
      defaultValue: flatDiscountInitialValue
    }, ({
      fieldProps
    }) => /*#__PURE__*/React.createElement(PricingTable, _extends({}, fieldProps, {
      mpacBaseUrl: mpacBaseUrl,
      selectedApps: promotionBasicsData.eligibleApps,
      flatDiscount: getValues().discountPercent,
      hostingType: promotionBasicsData.hostingType.value
    }))), /*#__PURE__*/React.createElement("div", null, getPromotionDiscountNote(promotionBasicsData.hostingType.value)), /*#__PURE__*/React.createElement(PromotionFooter, {
      actions: [{
        text: 'Back',
        props: {
          onClick: () => onChange(Stages.PROMOTION_BASICS)
        }
      }, {
        text: 'Next',
        props: {
          type: 'submit',
          appearance: 'primary'
        }
      }]
    }));
  });
};

export default DiscountAmount;